import { z } from 'zod';

export type ErrorDetail = { message: string; detail: string; validationErrors: string | undefined; error: Error | undefined } | null;

export const getErrorDetail = (error: Error | z.ZodError | unknown): ErrorDetail => {
    return {
        message: 'Failed to fetch workstream definition config data',
        detail: error instanceof z.ZodError
            ? 'A data validation error occurred.'
            : error instanceof Error
                ? error.message
                : `${error}`,
        validationErrors: error instanceof z.ZodError
            ? z.prettifyError(error)
            : undefined,
        error: error instanceof Error ? error : undefined
    };
};